export default __webpack_public_path__ + "static/media/Breeches of the Faceless Sphinx.ab796006.jpg";